// extracted by mini-css-extract-plugin
export default {"main":"VMqSK","rest":"c4JwX","title":"r7AxA","label":"IreQF"};